import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { AppUrl } from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService extends BaseService {

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  search(data): Observable<any> {
    return this.getRequest(AppUrl.SEARCH_ORGANISATION(), data);
  }

  getPlans(data: any = {}): Observable<any> {
    return this.getRequest(AppUrl.PLANS(), data);
  }
  planDetail(id: any): Observable<any> {
    return this.getRequest(AppUrl.PLAN_DETAIL(id));
  }

}
